import React, { useState } from 'react';
import PoleManagementFilters from '../components/PoleManagementFilters';
import PoleManagementSummary from '../components/PoleManagementSummary';
import PoleManagementTable from '../components/PoleManagementTable';
import PoleManagementSidebar from '../components/PoleManagementSidebar';
import PoleManagementExportPreview from '../components/PoleManagementExportPreview';

const PoleManagementPage = () => {
    const [filters, setFilters] = useState<any>(() => {
        return {
            status: 'Complete',
        };
    });
    const [tableData, setTableData] = useState<any[]>([]);
    const [exportType, setExportType] = useState('kmz');
    const [selectedExportFields, setSelectedExportFields] = useState<string[]>([
        'Job Number',
        'Pole Seq',
        'Pole No',
        'Is Pip',
        'Pole Type',
        'Pole Status',
    ]);

    return (
        <div className="flex flex-col gap-4 p-4 lg:p-6 w-full max-w-[100vw] overflow-x-hidden bg-[#F9FAFB] dark:bg-gray-900 min-h-screen">
            <div className="mb-2">
                <h1 className="text-2xl font-bold dark:text-gray-100">
                    Pole Management
                </h1>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    View all poles details within a selected period
                </p>
            </div>

            <PoleManagementFilters onFilterChange={setFilters} />
            {/* <PoleManagementSummary /> */}

            <div className="flex flex-col xl:flex-row gap-4 w-full mt-2">
                <div className="flex-grow w-full xl:w-[75%] bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 p-4">
                    <PoleManagementTable
                        filters={filters}
                        onDataLoaded={setTableData}
                    />
                </div>
                <div className="w-full xl:w-[25%] min-w-[280px] flex flex-col gap-4">
                    <PoleManagementSidebar
                        filters={filters}
                        tableData={tableData}
                        exportType={exportType}
                        setExportType={setExportType}
                        selectedExportFields={selectedExportFields}
                        setSelectedExportFields={setSelectedExportFields}
                    />
                </div>
            </div>

            <div className="mt-2 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 p-4">
                <PoleManagementExportPreview
                    tableData={tableData}
                    exportType={exportType}
                    selectedExportFields={selectedExportFields}
                />
            </div>
        </div>
    );
};

export default PoleManagementPage;
